import React from 'react';
import styled from 'styled-components';

import CheckboxIcon from '@/assets/svg/circular_checkbox_22px.svg';
import CheckboxCheckedIcon from '@/assets/svg/circular_checkbox_checked_22px.svg';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {}

function CircularCheckbox({ checked, className, ...other }: Props) {
  return (
    <Component className={className}>
      {checked ? <CheckboxCheckedIcon /> : <StyledCheckboxIcon />}
      <Input type="checkbox" checked={checked} {...other} />
    </Component>
  );
}

export default CircularCheckbox;

const Component = styled.div`
  position: relative;
  display: inline-flex;
  cursor: pointer;
`;

const StyledCheckboxIcon = styled(CheckboxIcon)`
  path {
    stroke: ${(props) => props.theme.black100};
  }
`;

const Input = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0;
  padding: 0;
  z-index: 1;
  cursor: inherit;
`;
